import { create } from 'zustand';
import { User } from '../types';

interface UserStore {
  users: User[];
  selectedUser: User | null;
  loading: boolean;
  error: string | null;
  filters: {
    status: 'all' | 'active' | 'inactive';
    search: string;
  };
  setUsers: (users: User[]) => void;
  setSelectedUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setFilters: (filters: Partial<UserStore['filters']>) => void;
  addUser: (user: User) => void;
  updateUser: (user: User) => void;
  removeUser: (userId: number) => void;
}

export const useUserStore = create<UserStore>((set) => ({
  users: [],
  selectedUser: null,
  loading: false,
  error: null,
  filters: {
    status: 'all',
    search: '',
  },
  setUsers: (users) => set({ users }),
  setSelectedUser: (user) => set({ selectedUser: user }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setFilters: (filters) => set((state) => ({ filters: { ...state.filters, ...filters } })),
  addUser: (user) => set((state) => ({ users: [...state.users, user] })),
  updateUser: (user) => set((state) => ({
    users: state.users.map((u) => (u.id === user.id ? user : u)),
  })),
  removeUser: (userId) => set((state) => ({
    users: state.users.filter((u) => u.id !== userId),
  })),
}));

